module.exports = __webpack_public_path__ + "img/error-icon.6333409d.png";